// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"206":"forum/components/EditPollModal","540":"forum/components/ListVotersModal","966":"forum/components/CreatePollModal"}[chunkId] + ".js";
};